import { render, staticRenderFns } from "./Etakst.vue?vue&type=template&id=15716df1&"
import script from "./Etakst.vue?vue&type=script&lang=js&"
export * from "./Etakst.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports